<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex>
        <h3 class="title grey--text text--darken-1 pt-0 pb-3">Bummer... The requested page could not be found.</h3>
        <p>Maybe go to my <router-link to="/">home</router-link> page or try search?</p>
        <search-form />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import SearchForm from '../components/SearchForm.vue'
  import Mixins from '../helpers/Mixins'

  export default {
    name: 'NotFound',
    components: {
      SearchForm
    },
    mixins: [
      Mixins
    ],
    mounted () {
      this.setTitle('Page not found')
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/NotFound.vue